import { getIsPunchOutSession } from "@insite/client-framework/Store/Context/ContextSelectors";
import convertSelectorToHook from "@store/Framework/Common/Utilities/convertSelectorToHook";
import { getCurrentLanguage, getSettingsCollection, getWebsite } from "@store/Framework/Store/Context/ContextSelectors";

export const useSettingsCollection = convertSelectorToHook(getSettingsCollection);
export const useWebsite = convertSelectorToHook(getWebsite);
export const useCurrentLanguage = convertSelectorToHook(getCurrentLanguage);
export const useIsPunchOutSession = convertSelectorToHook(getIsPunchOutSession);
